import React from 'react';
import ReactDomClient from 'react-dom/client';

import GeneratorApp from './generator-app.jsx';

document.body.style.margin = '0';
document.body.style.padding = '0';

const appTarget = document.createElement('div');
appTarget.id = 'generator-root';
document.body.appendChild(appTarget);

const root = ReactDomClient.createRoot(appTarget);
root.render(<GeneratorApp />);
